var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('folder-view',{attrs:{"encryptionStr":_vm.encryptionStr,"type":_vm.type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }